var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Store from "@ember-data/store";
import ModelRegistry from "@ember-data/types/registries/model";
import Owner from "@ember/owner";
import Service, { service } from "@ember/service";
import Coordinator from "core/services/-private/coordinator";
import { resolve } from "rsvp";
/**
 * The FetcherService is responsible for fetching data from the API.
 * It is for now a fork of Ember Data Storefront.
 */
let FetcherService = (_class = class FetcherService extends Service {
  constructor(properties) {
    super(properties);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _defineProperty(this, "coordinator", void 0);
    this.coordinator = new Coordinator(this.store);
  }

  /**
   `loadRecords` can be used in place of `store.query` to fetch a collection of records for the given type and options.
    ```diff
   this.get('store')
   -   .query('post', { filter: { popular: true } })
   +   .loadRecords('post', { filter: { popular: true } })
   .then(models => models);
   ```
    `loadRecords` caches based on the query you provide, so each of the following examples would return a blocking promise the first time they are called, and instantly resolve from the cache thereafter.
    ```js
   // filters
   store.loadRecords('post', { filter: { popular: true }});
    // pagination
   store.loadRecords('post', { page: { limit: 10, offset: 0 }});
    // includes
   store.loadRecords('post', { include: 'comments' });
    // force an already loaded set to reload (blocking promise)
   store.loadRecords('post', { reload: true });
   ```
    In most cases, `loadRecords` should be a drop-in replacement for `query` that eliminates bugs and improves your app's caching.
   */
  loadRecords(type, options = {}) {
    const query = this.coordinator.recordArrayQueryFor(type, options);
    const shouldBlock = options.reload || !query.value;
    const shouldBackgroundReload = options.backgroundReload !== undefined ? options.backgroundReload : true;
    let promise;
    let fetcher;
    if (shouldBlock) {
      promise = query.run();
      fetcher = promise;
    } else {
      promise = resolve(query.value);
      fetcher = shouldBackgroundReload ? query.run() : resolve();
    }
    fetcher.then(() => query.trackIncludes());
    return promise;
  }

  /**
   `loadRecord` can be used in place of `store.findRecord` to fetch a single record for the given type, id and options.
    ```diff
   this.get('store')
   -   .findRecord('post', 1, { include: 'comments' })
   +   .loadRecord('post', 1, { include: 'comments' })
   .then(post => post);
   ```
    `loadRecord` caches based on the query you provide, so each of the following examples would return a blocking promise the first time they are called, and synchronously resolve from the cache thereafter.
    ```js
   // simple fetch
   this.get('store').loadRecord('post', 1);
    // includes
   this.get('store').loadRecord('post', 1, { include: 'comments' });
   ```
    This solves many common bugs where `findRecord` would return immediately, even if important `includes` had never been loaded.
    Similar to `store.findRecord`, you can force a query to reload using `reload: true`:
    ```
   // force an already loaded set to reload (blocking promise)
   store.loadRecord('post', 1, { reload: true });
   ```
    In most cases, `loadRecord` should be a drop-in replacement for `findRecord` that eliminates bugs and improves your app's caching.
    @method loadRecord
   @param type type of model to load
   @param id id of model to load
   @param options (optional) a hash of options
   @return a promise resolving with the record array
   @public
   */
  loadRecord(type, id, options = {}) {
    const query = this.coordinator.recordQueryFor(type, id, options);
    const shouldBlock = options.reload || !query.value;
    const shouldBackgroundReload = options.backgroundReload !== undefined ? options.backgroundReload : true;
    let promise;
    if (shouldBlock) {
      promise = query.run();
    } else {
      promise = resolve(query.value);
      if (shouldBackgroundReload) {
        query.run();
      }
    }
    return promise;
  }
  query(modelName, query, options) {
    return this.store.query(modelName, query, options);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { FetcherService as default };